import { TrackingUtil } from '../utils/tracking';
import { UrlUtil } from '../utils/url-util';
import { FormView } from '../account/form-view';
import { ApiUtil } from '../utils/api-util';
import { LinkUtil } from '../utils/link';
import {BrowserSupport} from "../utils/browser-support";
import Cookies from 'js-cookie';
import constants from '../utils/constants';
import { FirebaseDatabase } from './firebase-database';
import firebase from "firebase/app"
import "firebase/auth";

export default FormView.extend({

    initialize: function(opts) {
        FormView.prototype.initialize.apply(this, [opts]);
        let queryRedirectUrl = opts.redirectUrl || UrlUtil.queryString("redirect");
        this.redirectUrl = queryRedirectUrl ? decodeURIComponent(queryRedirectUrl) : "/User/Settings/";
    },

    executeOperation: function() {
        let uname = this.el.querySelector("#uname");
        let email = this.el.querySelector("#email");
        let passwd = this.el.querySelector("#passwd");

        return new Promise((resolve, reject) => {

            // TODO: client-side validation
    
            let optin = this.el.querySelector('#signUpNewsletterOptIn:checked');
            let siteLocale = document.querySelector('body').getAttribute('data-locale');
            let campaignId = UrlUtil.queryString("campaignId");

            let gender = this.el.querySelector(".js-gender-radio:checked");
            let selectedGender = gender ? gender.value : null;
    
            firebase.auth()
                .createUserWithEmailAndPassword(email.value, passwd.value)
                .then(authUser => {
                    let userData = {
                        uid: authUser.user.uid,
                        email: email.value,
                        subscribeToNewsletter: true,
                        fullName: uname.value.trim(),
                        gender: selectedGender,
                        site: siteLocale,
                        provider: 'EMAIL'
                    };

                    return FirebaseDatabase.saveUser(userData);
                })
                .then(() => TrackingUtil.throwUserAuthenticationEvent('signUp', (campaignId ? (campaignId + ".") : "") + 'EMAIL'))
                .then(() => {
                    if (optin) {
                        let data = {
                            version: 2,
                            name: uname.value.trim(),
                            email: email.value,
                            isDeals: !!UrlUtil.queryString("isDeals", this.redirectUrl)
                        };

                        return new Promise((res, rej) => {
                            ApiUtil.request({
                                method: 'POST',
                                data: data,
                                path: constants.NEWSLETTER_SIGNUP_URL,
                                success: function() { 
                                    // TODO: Send tracking for user signup
                                    // TrackingUtil.throwGAEvent('Promotion', 'newsletter', 'user-signup-form', false);
                                    res(); 
                                },
                                error: function() { 
                                    // TODO: Report signup failure
                                    // JsErrorTrackingUtils.sendCustomError("Newsletter signup failed");
                                    res();
                                }
                            });
                        });
                    }
                })
                .then(() => {
                    if (BrowserSupport.isLocalStorageSupportedAndActive()) { 
                        sessionStorage.setItem('justSignedUp', '1');
                    }

                    Cookies.set(constants.COOKIE_IS_REGISTERED, 
                        "true", { expires: 365, secure: true });

                    LinkUtil.goToUrl(this.redirectUrl);
                })
                .catch((error) => {
                    switch (error.code) {
                        case 'auth/invalid-email':
                            reject(getI18N(jlocale.emailErrornotvalid));
                            break;
                        case 'auth/weak-password':
                            reject(getI18N(jlocale.weakPasswordError));
                            break;
                        case 'auth/email-already-in-use':
                            reject(getI18N(jlocale.signupEmailAlreadyExists));
                            break;
                        case 'auth/account-exists-with-different-credential':
                            reject(getI18N(jlocale.emailExistsWithOtherProviderRegister));
                            break;
                        case 'auth/credential-already-in-use':
                            reject(getI18N(jlocale.credentialAlreadyUsed));
                            break;
                        default:
                            reject(getI18N(jlocale.error));
                            break;
                    }
                });
        });
    }
});
